import { Item } from 'functions/src/types/firestore/Game/Collection/Item';
import { useServerTime } from 'src/contexts/useServerTime';

export type useActiveFulfillmentProps = Pick<Item<Date>, 'fulfillmentsRecent'>;

export function useActiveFulfillment({
  fulfillmentsRecent,
}: useActiveFulfillmentProps) {
  const { now } = useServerTime();

  return fulfillmentsRecent?.find(
    ({ createdAt, expiresAt }) =>
      createdAt.getTime() <= now() && expiresAt.getTime() >= now(),
  );
}
